import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=1d3a6c48&scoped=true"
import script from "./OwnerForm.vue?vue&type=script&lang=js"
export * from "./OwnerForm.vue?vue&type=script&lang=js"
import style0 from "./OwnerForm.vue?vue&type=style&index=0&id=1d3a6c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a6c48",
  null
  
)

export default component.exports